// @ts-nocheck
import { Cart } from '../types/cart.types';
import { Plan } from '../types/plan.types';

export const checkIfCartContractTypeSame = (cartFromHook: Cart, allPlans: Plan[], plan: Plan): boolean => {
  let cart = cartFromHook;
  if (cart?.result) {
    cart = cart.cart;
  }
  if (!cart || cart.items.length === 0) {
    return true;
  }
  if (!allPlans || allPlans.length === 0) {
    return false;
  }
  const cartMainItem = cart.items.find(item => item.offerItem?.type === 'main');

  if (!cartMainItem?.offerItem?.contentSlug) {
    return false;
  }
  const currentCartPlan = allPlans.find(p => p.bmId.toLowerCase() === cartMainItem.offerItem.contentSlug.toLowerCase());

  if (!currentCartPlan) {
    return false;
  }
  return plan?.contractType === currentCartPlan.contractType;
};
